import { BuildContext } from '../types';
import yieldToMainThread from './yieldToMainThread';

const PROGRESS_REPORT_EVERY_N_ROWS = 1000;

const reportProgressAndMaybeYield = async (
  context: BuildContext
): Promise<void> => {
  context.processedRows += 1;

  if (context.processedRows % PROGRESS_REPORT_EVERY_N_ROWS === 0) {
    context.onProgress?.(context.processedRows, context.totalRows);
  }

  if (
    Number.isFinite(context.yieldEveryNRows) &&
    context.processedRows % context.yieldEveryNRows === 0
  ) {
    await yieldToMainThread();
  }
};

export default reportProgressAndMaybeYield;
